import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  Fragment,
  useContext,
  useMemo,
} from 'react';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import matchArrays from '../../../utils/matchArrays';
import getParamFilterValue from '../../../utils/getParamFilterValue';
import { Context } from '../../../context/AppContext';
import { FILTERS } from '../../../constants';
import DropDown from './DropDown';
import NavButton from './NavButton';
import CheckBox from './CheckBox';
import ApplyButton from './ApplyButton';
import './styles.css';

const { PRICE_RANGE } = FILTERS;

const Price = ({
  fetchMore,
  filters,
  filter = '',
  selectedCount,
  filtersCount,
  updateFiltersCount,
  sort,
}) => {
  const {
    media: { tablet, desktop },
  } = useContext(Context);
  const [selected, setSelected] = useState('');
  const [dirty, setDirty] = useState(false);
  const [dropdownFilters, setDropdownFilters] = useState([]);

  const [show, setShow] = useState();
  const ref = useRef();

  useEffect(() => {
    setSelected(filter);
    setDirty(false);
  }, [filter]);

  useEffect(() => {
    setDropdownFilters(filters);
  }, [filters]);

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (show) {
        setSelected(filter);
        updateFiltersCount(filter);
        setShow(false);
        setDirty(false);
      }
    }, [filter, show])
  );

  const setFilter = useCallback(
    (value, add) => {
      const paramFilter = getParamFilterValue(selected, value, add);
      setSelected(paramFilter);
      updateFiltersCount(paramFilter);
      setDirty(true);
    },
    [selected]
  );

  const selectedValues = useMemo(
    () =>
      selected
        ? PRICE_RANGE.reduce((agg, { label, value }) => {
            if (selected.includes(value)) {
              return agg.concat(label);
            }
            return agg;
          }, [])
        : null,
    [selected]
  );

  const matchInitial = useMemo(() => {
    return matchArrays(
      selected ? selected.split(',').sort() : [],
      filter ? filter.split(',').sort() : []
    );
  }, [selected, filter]);

  return (
    <div className="Listview__Filters__wrapper" ref={ref}>
      {tablet || desktop ? (
        <Fragment>
          <NavButton
            className="Listview__Filters__button--price"
            active={!!selectedCount || show}
            onClick={() => setShow(!show)}
            hasSelected={selectedCount}
          >
            Price
          </NavButton>
          <DropDown show={show} heading="Price">
            <div className="Listview__Filters__options">
              {show &&
                dropdownFilters &&
                !!dropdownFilters.length &&
                dropdownFilters.map(({ label, checked, value }) => (
                  <CheckBox
                    key={label}
                    defaultChecked={checked}
                    disabled={!filtersCount[value] && !checked}
                    value={value}
                    onClick={e => setFilter(e.target.value, e.target.checked)}
                  >
                    {label}{' '}
                    {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                  </CheckBox>
                ))}
            </div>
            <ApplyButton
              active={dirty && !matchInitial}
              data-filter={selectedValues}
              onClick={e => {
                fetchMore(e, {
                  page: 0,
                  filter: selected,
                  sort,
                });
                setShow(false);
              }}
            >
              Apply
            </ApplyButton>
          </DropDown>
        </Fragment>
      ) : (
        <Fragment>
          {dropdownFilters.map(({ label, checked, value }) => (
            <Fragment key={label}>
              {checked ? (
                <NavButton
                  active={checked}
                  onClick={e => {
                    const paramFilter = getParamFilterValue(
                      selected,
                      value,
                      !checked
                    );
                    setSelected(paramFilter);
                    fetchMore(e, {
                      page: 0,
                      filter: paramFilter,
                      sort,
                    });
                  }}
                >
                  {label}{' '}
                  {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                </NavButton>
              ) : (
                ''
              )}
            </Fragment>
          ))}
        </Fragment>
      )}
    </div>
  );
};

export default Price;
